<template>
  <tr v-if="inventories">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">Closed Out</th>
    <td class="sheet-cell pa-0 text-center" v-for="(inventory, index) in inventories" :key="index">
      <v-progress-circular v-if="inventory.cou" size="12" width="2" indeterminate/>
      <v-btn v-else @click="update(inventory)" text block tile height="30" :ripple="false">
        <v-icon x-large style="line-height: 0;" v-text="inventory.close_out ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="inventory.close_out ? 'red' : 'grey darken-1'"/>
      </v-btn>
    </td>
  </tr>
</template>


<script>

  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      inventories: null
    },

    methods: {
      async update(data) {
        try {
          this.$set(data, 'cou', true);
          this.$set(data, 'close_out', !data.close_out);
          await sheet_repository.updateInventory(data);
        } catch (error) {
        } finally {
          this.$set(data, 'cou', false);
        }
      }
    }

  }
</script>


<style scoped>
  @import "../sheet.css";
</style>